import {
  AppImagePopup,
  IAppImagePopup,
} from 'components/AppImagePopup/AppImagePopup'
import { IPlanMenuControlDimensionDto } from 'core/api/dto/PlanMenuControlDto'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const FrozeDetailPhotoBlock = ({
  dimensionItem,
}: {
  dimensionItem: IPlanMenuControlDimensionDto
}) => {
  const thermoImg = dimensionItem?.thermoImageOnS3?.trim()
    ? dimensionItem.thermoImageOnS3
    : dimensionItem?.thermoImage

  const photoUrl = dimensionItem?.imageOnS3?.trim()
    ? dimensionItem?.imageOnS3
    : dimensionItem?.image

  const dishStandardImage = dimensionItem?.dishStandardImageOnS3?.trim()
    ? dimensionItem?.dishStandardImageOnS3
    : dimensionItem?.dishStandardImage
  return (
    <div className="photo-wrap">
      {thermoImg && (
        <FrozeDetailPhotoItem img={thermoImg} title="Тепловая карта" />
      )}
      {photoUrl && <FrozeDetailPhotoItem img={photoUrl} title="Фото замера" />}

      {dishStandardImage && (
        <FrozeDetailPhotoItem img={dishStandardImage} title="Эталонное фото" />
      )}
    </div>
  )
}

interface IFrozeDetailPhotoItem {
  img: string
  title: string
}

const FrozeDetailPhotoItem = ({ img, title }: IFrozeDetailPhotoItem) => {
  const { t } = useTranslation()
  const [imagePopup, setImagePopup] = useState<IAppImagePopup>({
    active: false,
    photo: null,
    title: null,
  })
  const closeImagePopupHandler = useCallback(() => {
    setImagePopup({ active: false, photo: null, title: null })
  }, [])
  const openImagePopupHandler = useCallback((photo: string, title: string) => {
    setImagePopup({ active: true, photo, title })
  }, [])

  return (
    <React.Fragment>
      {imagePopup.active && imagePopup.photo && (
        <AppImagePopup
          title={imagePopup.title || ''}
          img={imagePopup.photo}
          setActive={closeImagePopupHandler}
        />
      )}
      <div className="img-block">
        <div className="title">{t(title)}</div>
        <img src={img} alt="" />
        <div
          className="show-photo"
          onClick={() => openImagePopupHandler(img, t(title))}
        >
          <i className="an-ico an-ico-search" />
        </div>
      </div>
    </React.Fragment>
  )
}
